import { motion } from "motion/react";
import { Mail, Store, CreditCard, CheckCircle } from "lucide-react";

const steps = [
  {
    icon: Mail,
    step: "01",
    title: "メール認証",
    description: "メールアドレスを入力してワンタイムコードで認証。",
  },
  {
    icon: Store,
    step: "02",
    title: "店舗情報入力",
    description: "店名、住所、店舗の種類などを入力。1分で完了。",
  },
  {
    icon: CreditCard,
    step: "03",
    title: "決済設定",
    description: "Stripeで安全にお支払い。初月無料コード「CASHFIRST」を入力。",
  },
  {
    icon: CheckCircle,
    step: "04",
    title: "自動公開",
    description: "決済完了後、即座にマップ上に公開。店舗管理ページで決済方法や店舗情報を編集。お客さまがすぐに検索できるようになります。",
  },
];

export function HowItWorks() {
  return (
    <section className="py-24 bg-gradient-to-br from-purple-50 to-blue-50 dark:from-purple-950/20 dark:to-blue-950/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <span className="px-4 py-2 rounded-full bg-gradient-to-r from-purple-600/20 to-blue-600/20 border border-purple-600/30 text-purple-600">
            導入の流れ
          </span>
          <h2 className="mt-6 bg-gradient-to-r from-foreground to-foreground/70 bg-clip-text text-transparent">
            最短1分で掲載開始
          </h2>
          <p className="mt-4 max-w-2xl mx-auto text-muted-foreground">
            複雑な手続きは一切なし。すぐに始められて、すぐに効果が出ます。
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="relative"
            >
              <div className="bg-card border border-border rounded-2xl p-6 h-full">
                <div className="flex items-center justify-between mb-4">
                  <div className={`p-3 rounded-xl bg-gradient-to-r ${
                    index === 0 ? "from-purple-500 to-pink-500" :
                    index === 1 ? "from-blue-500 to-cyan-500" :
                    index === 2 ? "from-green-500 to-emerald-500" :
                    "from-yellow-500 to-orange-500"
                  }`}>
                    <step.icon className="text-white" size={24} />
                  </div>
                  <span className="text-5xl opacity-10">{step.step}</span>
                </div>
                <h3 className="mb-3">{step.title}</h3>
                <p className="text-muted-foreground text-sm">{step.description}</p>
              </div>

              {/* Arrow between steps (desktop only) */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                  <div className="w-8 h-0.5 bg-gradient-to-r from-purple-600/50 to-blue-600/50" />
                  <div className="absolute right-0 top-1/2 transform -translate-y-1/2 w-0 h-0 border-t-4 border-t-transparent border-b-4 border-b-transparent border-l-4 border-l-purple-600/50" />
                </div>
              )}
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          viewport={{ once: true }}
          className="text-center mt-12"
        >
          <p className="text-muted-foreground">
            登録完了後すぐに利用開始できます
          </p>
        </motion.div>
      </div>
    </section>
  );
}
